import React from 'react';
import '../../assets/styles/product.price.css';
import { getFormattedPriceParts, getProductPriceSummary } from '../../utils/priceUtils';

const ProductPrice = ({ product, userInfo, qty = 0, size = 'medium', className = '' }) => {
    if (!product) return null;

    const {
        fullBasePrice,
        finalPrice: discountedPrice,
        effectiveDiscount,
        hasValidDiscount,
    } = getProductPriceSummary(product, userInfo);

    const [baseInt, baseCents] = getFormattedPriceParts(fullBasePrice);
    const [finalQtyInt, finalQtyCents] = getFormattedPriceParts(discountedPrice * qty);
    const [finalInt, finalCents] = getFormattedPriceParts(discountedPrice);

    return (
        <div className={`ProductPrice-container price-${size} ${className}`}>
            <div className="ProductCard-original text-end">
                {hasValidDiscount && fullBasePrice > 0 && (
                    <>
                        <div className="ProductCard-before-discount">
                            <span>
                                ${baseInt}
                                <span className="ProductCard-cents">.{baseCents}</span>
                            </span>
                        </div>
                        <span className="ProductPrice-discount-badge">
                            -{effectiveDiscount.toFixed(0)}%
                        </span>
                    </>
                )}
            </div>

            <div className="ProductCard-original text-end">
                <span>
                    ${finalInt}
                    <span className="ProductCard-cents">.{finalCents}</span>
                </span>
            </div>

            {qty > 0 && (
                <>
                    <div className="ProductCard-original text-end">
                        <span> x {qty} = &nbsp; </span>
                        <span>
                            ${finalQtyInt}
                            <span className="ProductCard-cents">.{finalQtyCents}</span>
                        </span>
                    </div>
                </>
            )}
        </div>
    );
};

export default ProductPrice;
